import { useState } from 'react';

import { Box, Icon, Link, TextPrice } from '@core/component';
import { EActionAttribute, EColor, EIcon, ESize, ETypographyVariant } from '@core/type';
import { ModalPricingDetails, ModalPricingDetailsProps, ProductPriceWrapper } from '@core/widget';

import { LOGISTIC_RADIO_TRANSITION } from './constants';

export const BadgeProductPrice = ({
  isActive,
  totalPrice,
  totalPriceWithDeal,
  deal,
  ...restProps
}: {
  isActive: boolean;
} & Omit<ModalPricingDetailsProps, 'isOpen' | 'onCloseModal'>) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <>
      <Box display={'flex'} marginBottom={'2px'}>
        <ProductPriceWrapper
          role={'button'}
          color={isActive ? EColor.ACCENT : EColor.PRIMARY}
          transition={LOGISTIC_RADIO_TRANSITION}
          onClick={(e) => {
            e.preventDefault();
            setIsOpen(true);
          }}
          isUnderlinedHover={false}
        >
          {deal ? (
            <Box display="flex" flexWrap="wrap" gap="5px">
              <Box display="flex">
                <TextPrice
                  display={'inline'}
                  price={totalPriceWithDeal}
                  marginBottom={'4px'}
                  textDecoration="underline"
                  color={EColor.DANGER}
                  variant={ETypographyVariant.H4}
                />
                <Box display="flex" alignItems="flex-start">
                  <Icon type={EIcon.INFO} color={EColor.DANGER} size={ESize.XXS} />
                </Box>
              </Box>

              <TextPrice
                display={'inline'}
                price={totalPrice}
                color={EColor.SECONDARY}
                variant={ETypographyVariant.H4}
                integerProps={{ textDecoration: 'line-through' }}
                fractionProps={{ textDecoration: 'line-through' }}
              />
            </Box>
          ) : (
            <>
              <Box>
                <Link as={EActionAttribute.SPAN}>
                  <TextPrice display={'inline'} price={totalPrice} marginBottom={'4px'} />
                </Link>
              </Box>
              <Box display="flex" alignItems="flex-start">
                <Icon type={EIcon.INFO} color={EColor.INFO} size={ESize.XXS} />
              </Box>
            </>
          )}
        </ProductPriceWrapper>
      </Box>
      <ModalPricingDetails
        onCloseModal={() => setIsOpen(false)}
        isOpen={isOpen}
        totalPrice={totalPrice}
        deal={deal}
        totalPriceWithDeal={totalPriceWithDeal}
        {...restProps}
      />
    </>
  );
};
